import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import {
  AsyncCallArgs,
  GridContainer,
  GridItem,
  handleSubmitValidationFail,
  RichTextFormField,
  useAsyncCall,
  useReactHookForm,
  ViewDialog,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { FormProvider } from "react-hook-form";
import { ServiceDefinitionSaveDetails } from "../../../../../../types/serviceDefinitionTypes";
import { serviceDefinitionSaveInitialValues } from "../../../../../../init/serviceDefinitionSaveInitialValues";
import { createServiceDefinitionSaveValidationSchema } from "../../../../../../yup/schema/serviceDefinition/serviceDefinitionSaveValidationSchema";
import SelectServices from "../SelectServices";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/serviceDefinitionControl";
import { createServiceDefinition } from "../../../../../../axios/api/services";
import { toast } from "react-toastify";
import useViewDataObject from "../../../../../../hooks/redux/useViewDataObject";
import { VIEW_TYPES } from "../../../../../../config/view/types";
import { addViewObject } from "../../../../../../store/redux/slice/ViewData/viewDataPage";
const ServiceDefinitionCreateDialog = () => {
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();
  const { t } = useTranslation();
  const { open } = useAppSelector((state) => {
    return state.ComponentsControl.serviceDefinitionControl.modals.create;
  });
  const { data: serviceDefinitionsViewData } = useViewDataObject(VIEW_TYPES.SERVICE_DEFINITION_EDIT);

  const { methods } = useReactHookForm<ServiceDefinitionSaveDetails>({
    defaultValues: serviceDefinitionSaveInitialValues,
    validationSchema: createServiceDefinitionSaveValidationSchema,
  });

  const handleCloseDialog = () => {
    methods.reset(serviceDefinitionSaveInitialValues);
    dispatch(closeModal({ modalType: "create" }));
  };

  const onSubmit = (values) => {
    const asyncCreation: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: createServiceDefinition(values),
      reactHooksForm: { methods },
      onSuccess: () => {
        const viewType = VIEW_TYPES.SERVICE_DEFINITION_EDIT;
        const payload = { viewType, data: [...serviceDefinitionsViewData, methods.getValues("id")] };
        dispatch(addViewObject(payload));
        methods.reset(serviceDefinitionSaveInitialValues, {
          keepIsSubmitted: true,
          keepSubmitCount: true,
        });
        toast.success(t("m.create.serviceDefinition.success"));
        handleCloseDialog();
      },
    };
    asyncCall(asyncCreation);
  };

  return (
    <ViewDialog
      open={open}
      onClose={handleCloseDialog}
      title={"t.service.definition.create.dialog"}
      disableEnforceFocus
      dialogActionsSpacing={{ pr: 3 }}
      onSubmitBtnClick={methods.handleSubmit(onSubmit, () => handleSubmitValidationFail(methods.formState, t))}
    >
      <FormProvider {...methods}>
        <form>
          <GridContainer spacing={5}>
            <GridItem sm={12} md={12}>
              <SelectServices fieldName={"id"} labelCode={"l.serviceDefinition.id"}></SelectServices>
            </GridItem>
            <GridItem sm={12} md={12}>
              <RichTextFormField
                fieldName={"content"}
                onChangeMethod={(content) => methods.setValue("content", content)}
              />
            </GridItem>
          </GridContainer>
        </form>
      </FormProvider>
    </ViewDialog>
  );
};

export default ServiceDefinitionCreateDialog;
